<template>
  <div class="normal-select-container">
    <p class="pleachgholder" :class="{ selecting: showOption }" @click="showOption = !showOption">
      Select {{ name }}
    </p>
    <div class="options" v-if="showOption" v-click-outside="() => (showOption = false)">
      <p v-for="(i, index) in isInfo" @click="isSetStatus(index, i._id)" class="option" :class="{ selected: i.isCheck }">
        <i class="fa-light fa-circle"></i>
        {{ i.name }}
      </p>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: ["info", "name"],
  data: () => ({
    showOption: false,
    isInfo: [],
    setId: [],
  }),
  methods: {
    isSetStatus(index, id) {
      const isCheck = this.setId.find((f) => f === id);
      if (isCheck) {
        this.isInfo.forEach((item, idx) => {
          if (item._id === id) this.isInfo[idx].isCheck = false;
        });
        this.setId.forEach((i, index) => {
          if (i === id) this.setId.splice(index, 1);
        });
      } else {
        this.isInfo.forEach((item, idx) => {
          if (item._id === id) this.isInfo[idx].isCheck = true;
        });
        this.setId.push(id);
      }
    },
  },
  watch: {
    setId: {
      handler(val) {
        if (val) {
          this.$emit("input", val);
        }
      },
      immediate: true,
    },
    info() {
      this.isInfo = this.info.map((i) => {
        return {
          _id: i._id,
          name: i.name,
          isCheck: false,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.normal-select-container {
  font-size: var(--sm-font);
  position: relative;

  .pleachgholder {
    width: 100%;
    margin: 0 !important;
    position: relative;
    display: flex;
    align-items: center;
    height: 2.5rem;
    border: 1px solid var(--border-color);
    border-radius: var(--radius);
    padding-bottom: calc(0.5em - 1px);
    padding-left: calc(0.75em - 1px);
    padding-right: 30px;
    padding-top: calc(0.5em - 1px);
    background-color: var(--light-grey-color);
    transition: all ease-in-out 0.3s;
    cursor: pointer;

    &:hover {
      background-color: var(--grey-color);
    }

    &::after {
      content: "";
      position: absolute;
      right: 10px;
      border-left: solid 5px transparent;
      border-right: solid 5px transparent;
      border-top: solid 5px var(--dark-grey-color);
      height: 0;
      width: 0;
    }

    &.selecting {
      background-color: var(--grey-color);
    }
  }

  .options {
    position: absolute;
    flex-grow: 1;
    width: 100%;
    z-index: 999;
    top: 3rem;
    border: 1px solid var(--border-color);
    border-radius: var(--radius);
    background-color: #fff;
    padding: 1rem 0;
    box-shadow: 0px 2px 4px 0px rgba(#000, 0.15);

    .option {
      transition: all ease-in-out 0.3s;
      padding: 0 20px;
      user-select: none;
      cursor: pointer;
      height: 2.5rem;
      margin: 0;
      width: 100%;
      flex-grow: 1;
      display: flex;
      gap: 8px;
      justify-content: flex-start;

      &:hover {
        background-color: rgba(var(--primary-color-rgb), 0.05);
        color: var(--primary-color);
      }

      &.selected {
        color: var(--primary-color);

        i {
          font-weight: 700;
          color: var(--primary-color);
        }
      }

      i {
        color: var(--text-color);
      }
    }
  }
}
</style>
